import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from "@angular/core";
import {User} from "../../../objects/users/user";
import {ModalDirective} from "ngx-bootstrap";
import {UserFlag} from "../../../objects/users/userFlag";
import {NgForm} from "@angular/forms";
import {UserService} from "../../../services/userService";
import {BaseResponse} from "../../../objects/common/baseResponse";
import {UserHelper} from "../../../common/helpers/userHelper";
import {ConfigService} from "../../../services/configService";
import {Cookie} from "ng2-cookies/ng2-cookies";
import {GoogleContact} from "../../../objects/google/googleContact";
import {Group} from "../../../objects/groups/group";
import {BlurUtil} from "../../../common/utils/blurUtil";
import {Router} from '@angular/router';
import {OrderService} from "../../../services/orderService";
import {SearchResponse} from "../../../objects/responses/searchResponse";
import {Order} from "../../../objects/orders/order";
import {Select2Util} from "../../../common/utils/select2Util";
import * as ps from "perfect-scrollbar";
import { StorageManager } from "../../../common/managers/storageManager";
import { OrderViewType } from "../../../objects/management/order/orderViewType";
import { UserViewHelper } from "../../../common/helpers/userViewHelper";
import { Component as ComponentEnum } from "../../../objects/components/component";
import { UserViewService } from "../../../services/userViewService";
/**
 * Created by vlad.p on 8/1/2017.
 */

declare var $: any;

@Component({
    selector: 'agent-modal',
    templateUrl: 'agent-modal.component.html',
    moduleId: module.id.toString()
})
export class AgentModalComponent implements OnInit {
    @Input()
    public groups: Group[];

    @Output()
    public agentSaved: EventEmitter<User> = new EventEmitter();

    @ViewChild('agentModal')
    public agentModal: ModalDirective;
    @ViewChild("agentForm")
    public agentForm: NgForm;

    @ViewChild('ag') agentModalRef: ElementRef;

    public originalAgent: User = new User();
    public currentAgent: User = new User();

    public string = String;
    public number = Number;
    public userFlag = UserFlag;
    public userHelper = UserHelper;

    public select2Util = Select2Util;
    public processing: boolean = false;

    @Input()
    public idToBlur: string;

    public contacts: any[] = [];

    private top: number = 10;
    private skip: number = 3;
    private hasNextOrder: boolean = true;

    public isOrderLoading: boolean = false;
    public showSelect: boolean = false;
    public currentUser : User;

    public tableColumns: any[] = [];

    constructor(public userService: UserService,
                private configService: ConfigService,
                private router: Router,
                private storageManager : StorageManager,
                public userViewService: UserViewService) {

    }

    public async ngOnInit(): Promise<void> {
        ps.initialize(this.agentModalRef.nativeElement);
        this.currentUser = await this.storageManager.getCurrentUser();
    }


    @HostListener('scroll', ['$event'])
    @HostListener('mousewheel', ['$event'])
    onMousewheel() {
        let delta = document.getElementById("myModal").clientHeight - document.getElementById("myModal").scrollHeight == 0;

        if (delta && !this.isOrderLoading)
            this.loadNextOrders();
    }

    @HostListener('document:keydown', ['$event'])
    onArrowDown(event: any){
        if(this.isOrderLoading)
            return;

        if(event.keyCode == 38 || event.keyCode == 40)
            this.loadNextOrders();
    }

    public viewAllOrders(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
        this.router.navigate(["management/order", {agentid: this.currentAgent.Id}]);
    }

    public handleScroll(): void {
        this.loadNextOrders();
    }

    public loadNextOrders(): void {
        if (!this.hasNextOrder)
            return;

        this.isOrderLoading = true;
        this.userService.getOrdersByAgentId(this.currentAgent.Id, this.skip, this.top).then((result: BaseResponse<SearchResponse<Order>>) => {
            this.isOrderLoading = false;

            if (!result || !result.Data)
                return;

            if (result.Data.Items.length == 0 || this.originalAgent.Orders.length == result.Data.TotalCount)
                this.hasNextOrder = false;

            this.skip += this.top;

            result.Data.Items.sort((x, y) => {
                return new Date(x.Created) > new Date(y.Created) ? -1 : 1;
            });

            for (let o of result.Data.Items) {
                this.currentAgent.Orders.push(o);
                this.originalAgent.Orders.push(o);
            }
        })
    }

    public show(agent: User): void {
        this.top = 10;
        this.skip = agent.Orders.length;
        this.hasNextOrder = true;

        this.originalAgent = agent;
        this.currentAgent = JSON.parse(JSON.stringify(agent));
        this.agentModal.show();

        BlurUtil.blurMenu(this.idToBlur);
        this.showSelect = true;
        setTimeout(x=> {
            this.initSelect();
        },200);

        this.tableColumns = UserViewHelper.getColumns(this.userViewService, ComponentEnum.OrderManagement, OrderViewType.Tile);
    }

    public onModalHidden(): void {
        let select = $('#emailModel');
        select.select2('destroy');
        select.off('select2:select');
        select.off('select2:unselect');

        this.agentForm.resetForm();

        this.showSelect = false;

        BlurUtil.unBlurMenu(this.idToBlur);
    }

    public toggleEnabled(): void {
        if (this.currentAgent.Flag.hasFlag(UserFlag.Disabled)) {
            this.currentAgent.Flag &= ~UserFlag.Disabled;
        } else {
            this.currentAgent.Flag |= UserFlag.Disabled;
        }
    }


    public save(isValid: boolean): void {
        if (!isValid)
            return;

        this.processing = true;

        this.currentAgent.FullName = this.currentAgent.FirstName + ' ' + this.currentAgent.LastName;

        if (this.currentAgent.Id != null && String.isNullOrEmpty(this.currentAgent.Id.toString())) {
            this.userService.create(this.currentAgent).then(response => {
                this.onSaveSuccess(response);
            });
        } else {
            this.userService.update(this.currentAgent).then(response => {
                this.onSaveSuccess(response);
            });
        }
    }

    private onSaveSuccess(response: BaseResponse<User>): void {
        this.processing = false;
        this.agentSaved.emit(response.Data);
        this.agentModal.hide();
    }

    public cancel(): void {
        this.agentModal.hide();
    }

    public groupChanged(group: Group): void {
        if (UserHelper.isInGroup(this.currentAgent, group)) {
            this.currentAgent.Groups = this.currentAgent.Groups.filter(x => x.Id != group.Id);
        } else {
            this.currentAgent.Groups.push(group);
        }
    }

    private initSelect(): void {

        let data = this.currentAgent.Id != null
            ? [{id: this.currentAgent.Email, text: this.currentAgent.Email, object: this.currentAgent}]
            : [];

        var self = this;

        $('#emailModel').select2({
            width: '100%',
            data: data,
            allowClear: true,
            placeholder: '',
            ajax: {
                url: this.configService.config.ApiUrl + "/google/contacts/search",
                datatype: 'json',
                delay: 500,

                headers: {
                    'Authorization': 'Bearer ' + Cookie.get(this.configService.config.ApiTokenCookieName),
                },
                data: function (params: any) {
                    return {
                        query: params.term
                    };
                },
                processResults: function (data: BaseResponse<GoogleContact[]>, params: any) {

                    let results: any[] = data.Data.map(function (item: any) {
                            return {
                                id: item.Email,
                                text: item.Email,
                                object: item
                            };
                        }
                    );

                    // if (results.length == 0)
                    //     results.push({id: params.term, text: params.term});

                    self.contacts = results;

                    return {
                        results: results
                    };
                }
            },
            minimumInputLength: 2
        }).on('select2:select', function (e: any) {
            let selectedEmail = $('#emailModel').select2('val');

            let selectedContact = self.contacts.find(x => x.id == selectedEmail);

            self.currentAgent.Email = selectedEmail;

            self.agentForm.control.get('emailModel').setValue(selectedEmail);
            self.agentForm.control.get('emailModel').markAsTouched();

            if (selectedContact == null || selectedContact.object == null)
                return;

            self.currentAgent.FirstName = selectedContact.object.FirstName;
            self.currentAgent.LastName = selectedContact.object.LastName;
            self.currentAgent.ImageSrc = selectedContact.object.ImageUrl;

        }).on('select2:unselect', function (e: any) {
            self.currentAgent.Email = '';
            self.agentForm.control.get('emailModel').markAsTouched();
        });

        if (this.currentAgent.Id != null) {
            $('#emailModel').val(this.currentAgent.Email).trigger("change");
        }

        if(this.currentAgent.Id)
            $('#emailModel').select2('enable', false);

    }
}


// WEBPACK FOOTER //
// ./app/components/agent/modal/agent-modal.component.ts